import React, {Fragment, useLayoutEffect, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isLoggedIn} from "modules/selectors";
import {getSessionUser, saveLoginPayloadStore} from "modules/actions";
import {SSO} from "modules/utils/SSO";
import {Preloader} from "components/Preloader";
import RallySSO from "modules/utils/SSO/rallySSO";
import {HOCCheckUserName, HOCLoginService} from "components/";
import {createFanHubEventScriptTag, EventGUID} from "modules/utils/Services/analytics";

interface IProps {
	children: React.ReactElement;
}

export const HOCServiceSSO: React.FC<IProps> = ({children}) => {
	const dispatch = useDispatch();
	const isAuth = useSelector(isLoggedIn);
	const [isLoadingSSO, setIsLoadingSSO] = useState(true);

	useEffect(() => {
		createFanHubEventScriptTag(EventGUID.HomepageLoad);
	}, []);

	useLayoutEffect(() => {
		if (!isAuth) {
			const sso = new SSO();
			setIsLoadingSSO(true);

			if (SSO.IS_BACKDOOR_MODE) {
				dispatch(getSessionUser());
				setIsLoadingSSO(false);
				return;
			}

			if (RallySSO.IS_NATIVE) {
				void sso.initRallySSO().then(() => {
					dispatch(saveLoginPayloadStore(sso.toJSON()));
					setIsLoadingSSO(false);
				});
			} else {
				void sso.initWebAuthSSO().then(() => {
					dispatch(saveLoginPayloadStore(sso.toJSON()));
					setIsLoadingSSO(false);
				});
			}
		}
	}, [dispatch, isAuth]);

	if (isLoadingSSO) {
		return <Preloader fixed />;
	}

	if (SSO.IS_BACKDOOR_MODE) {
		return <Fragment>{children}</Fragment>;
	}

	return (
		<HOCCheckUserName>
			<HOCLoginService checkTerms={false}>{children}</HOCLoginService>
		</HOCCheckUserName>
	);
};

export default HOCServiceSSO;
